<template>

  <div>

    <SpotFolderDialog :command="command"
                      v-if="modalDialogSpotFolder"
                      :foreign-key="foreignKey"
                      :primary-key="form.spotFolderId"
                      :spot-folder-id="form.spotFolderId"
                      :enterprise-id="enterpriseId"
                      :division-name="divisionName"
                      :set-user-auth="userAuth"
                      :set-tab-index="modalDialogSpotFolderTabIndex"
                      @onClose="modalDialogSpotFolder = false"
                      @onSubmit="onSpotFolderDialog"/>

    <t-dialog-duplicate dialog-id="modal-duplicate-spot-folder" v-if="formDuplicateShow" :origin="formDuplicate.origin"
                        :path-server="currentPage.path" :form-error="formDuplicateError"
                        v-model="formDuplicate" :title="currentPage.singularTitle" @onSubmit="onDuplicated">

      <template #default="{status}">
        <t-input hide-label :status="status" v-model="formDuplicate.processFlowId" hidden/>
        <t-input hide-label :status="status" v-model="formDuplicate.processFlowStepId" hidden/>
        <t-input label="Pavimento" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>

      </template>
    </t-dialog-duplicate>


    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status" :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="spotFolderId" :primary-key="form.spotFolderId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Pavimentos"
                 enable-change-order-up-down
                 sortable
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit"
                 @onItemRead="onSpotFolderReadItem"
                 @onItemDelete="onItemDeleteDefault">

      <template #default>

        <div class="ml-1 mb-3">

          <t-button primary @click="openSpotFolderInsert">
            <b-icon-plus/>
            {{ t('insert') + ' Pavimento' }}
          </t-button>

        </div>

      </template>

      <template #item(name)="{item}">

        <span>{{ item.name }}</span>

        <small v-if="item.typeSpotFolder !== ''"><br/>{{ item.typeSpotFolder }}</small>

        <div v-if="item.sharingEnable"><a :href="item.sharingURL" target="_blank">{{ item.sharingURL }}</a></div>

      </template>

      <template #item(qtyOccurrencePending)="{item}">

        <b-button v-if="item.qtyOccurrencePending > 0"
                  :to="{path: '/checklist/occurrence?spotFolderId='+item.spotFolderId+'&hasOccurrencePending=true'}"
                  variant="outline-primary" size="sm" target="_blank">
          <b-icon-box-arrow-up-right class="mr-2"/>
          Apontamentos
          <b-badge variant="warning" v-b-tooltip.hover title="Qtd. de apontamentos pendentes">
            {{ item.qtyOccurrencePending }}
          </b-badge>
        </b-button>

        <small v-else>Nenhum pendente</small>

      </template>

      <template #item(buttonEnvironment)="{item}">
        <t-button @click="onSpotFolderReadItem(item.spotFolderId, 1)">Ambientes ({{item.qtyEnvironment}})</t-button>
      </template>


      <template #append-default-buttons="{item}">

        <b-button @click="openDialogDuplicate(item.enterpriseDivisionId, item.spotFolderId, item.name)"
                  class="opacity-6-hover"
                  v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                  title="Duplicar Local">
          <b-icon-files variant="primary"/>
        </b-button>

      </template>

    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import SpotFolderDialog from "@/views/modules/place/SpotFolderDialog";
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList, SpotFolderDialog, TDialogDuplicate},
  name: 'EnterpriseSpotFolder',
  data() {
    return {
      path: "place/spot-folder", //Utilizar somente quando fora do padrão
      pathMethodComplement: "/selectAll",
      foreignKeyColumn: "enterpriseDivisionId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "spotFolderId", keyDelete: "spotFolderId"},
        {key: "name", label: "Pavimento", cols: "4"},
        {key: "buttonEnvironment", label: "Ambientes", cols: "2"},
        {key: "qtyOccurrencePending", label: "Apontamentos", cols: "3"},
      ],
      form: {
        enterpriseDivisionId: this.foreignKey,
        spotFolderId: 0,
        spotFolderNumber: 0,
        orderList: 0,
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      modalDialogSpotFolder: false,
      modalDialogSpotFolderTabIndex:0,
      formDuplicateShow: false,
      formDuplicate: {
        enterpriseDivisionId: 0,
        spotFolderId: 0,
        changeName: "",
        origin: "",
      },
      formDuplicateError: {
        name: "",
      }
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    enterpriseId: {
      type: Number,
      required: true,
    },
    divisionName: {
      type: String,
      default: ""
    },
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.spotFolderId)

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    openSpotFolderInsert() {
      this.form.spotFolderId = 0
      this.command = 'insert'
      this.modalDialogSpotFolder = true
      this.modalDialogSpotFolderTabIndex = 0
      this.openDialogForm('modal-place-stop-folder')
    },
    onSpotFolderReadItem(id,tabIndex = 0) {
      this.form.spotFolderNumber = id
      this.form.spotFolderId = id
      this.command = 'update'
      this.modalDialogSpotFolder = true
      this.modalDialogSpotFolderTabIndex = tabIndex

      this.openDialogForm('modal-place-stop-folder')
    },

    async onSpotFolderDialog() {

      //Atualiza a listagem
      await this.getList()

    },
    openDialogDuplicate(enterpriseDivisionId, spotFolderId, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.enterpriseDivisionId = enterpriseDivisionId
      this.formDuplicate.spotFolderId = spotFolderId
      this.formDuplicate.origin = origin
      this.formDuplicate.changeName = origin

      this.openDialogForm('modal-duplicate-spot-folder')

    },

    onDuplicated(item) {

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicada", "Nova etapa <b>" + item.name + "</b> duplicada com sucesso!", "success", "b-toaster-top-center", true)

      this.getList()
    },
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
